var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationContactPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_3411_673)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3411_673",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3411_673",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3411_673",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAchJREFUSA3dlS8sbnEYxz9BEARBEARREAThBkEQBEG48QZBEATxBkEQBEGwsRFstCvYaGyKTWAT3GBzNzZBEMQbOZ/t+b37eZ2Xc95X8mzvznN+5/lz3u/z/T4HqtkAsAj8AXaBeaCnWurnUVPAI7AO/AR+ATvAHfDj8/SPI4aAJ2CkJGwSuAd6S55VPjoKOEzoB7bip6+tFVCtht/W5Tl7w+0ouAnoa2PAWfi1L/71/1lWauBbpwbDwE0WU9v9G29porBY2F+CaA7Yq101S5gtBnyQ3Te7V8B482Gd++6Clv8AGdNsM53gnxebAG4BmyXrC/o6gy8xhSV7tC7gOJQdR51fXAsqd7ootVQM/iQadVRZFfu2yVwLqvohY1F6JmSVzMAF4Dr4neiYktVGPot0rhYuQvWlzRykm1Llinc71LOGmrCGtbxvmHJ/iVUw2Dit7wirZLDWuxUi5Vxc4nwaa7kMjua2EkBFn8daXwFs1NIcrHvfTWqzjcIfLYkWAj8+QrIP+N3ISfEmRaUehqDyB37JfoeaHbwEWA4mXbYYqnE2fjPHNAMhajUDEySA27SVgoXGmG84gxz33G9nBnl+Lb/KDN4VfAW8aWLfOz3fJAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationContactPage);
export default __webpack_public_path__ + "static/media/location-contact-page.02cf14b510dd6c7777132a9ee3ac33c4.svg";
export { ForwardRef as ReactComponent };